import { Search, X } from "lucide-react";
import { CATALOG_CATEGORIES } from "@/data/catalog";
import { useLang } from "@/lib/i18n";

const Group = ({ title, children }) => (
  <div className="mt-7 first:mt-0">
    <p className="mono mb-2 text-[11px] text-[var(--muted)]">{title}</p>
    <div className="flex flex-col gap-0.5">{children}</div>
  </div>
);

const Opt = ({ on, label, count, onClick, testid }) => (
  <button type="button" onClick={onClick} className={`bk-filter ${on ? "bk-filter-on" : ""}`} data-testid={testid}>
    <span className="truncate">{label}</span>
    {count != null && <span className="mono text-[10px] opacity-70">{count}</span>}
  </button>
);

export const Filters = ({ facets, value, set }) => {
  const { t } = useLang();
  const cats = Array.isArray(facets?.categories) ? facets.categories : [];
  const brands = Array.isArray(facets?.manufacturers) ? facets.manufacturers : [];
  const decades = Array.isArray(facets?.decades) ? facets.decades : [];
  const toggle = (k, v) => set(k, value[k] === String(v) ? null : String(v));
  const active = ["categoria", "marca", "decada", "q"].some((k) => value[k]);
  return (
    <div data-testid="catalog-filters">
      <label className="relative block">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--muted)]" />
        <input value={value.q ?? ""} onChange={(e) => set("q", e.target.value || null)} placeholder={t("book.search")} className="support-input !py-2.5 !pl-9 text-sm" data-testid="catalog-search-input" />
      </label>
      {active && (
        <button type="button" onClick={() => set("__clear")} className="mono mt-3 inline-flex items-center gap-1 text-[11px] text-[var(--green)]" data-testid="catalog-clear-filters">
          <X size={12} /> {t("book.clear")}
        </button>
      )}
      <div className="mt-6">
        <Group title={t("book.category")}>
          {CATALOG_CATEGORIES.map((c) => (
            <Opt key={c.id} on={value.categoria === c.id} label={t(`cat.${c.id}`)} count={cats.find((x) => x.id === c.id)?.count ?? 0} onClick={() => toggle("categoria", c.id)} testid={`filter-cat-${c.id}`} />
          ))}
        </Group>
        <Group title={t("book.brand")}>
          {brands.map((b) => <Opt key={b.name} on={value.marca === b.name} label={b.name} count={b.count} onClick={() => toggle("marca", b.name)} testid={`filter-brand-${b.name.replace(/\W+/g, "-").toLowerCase()}`} />)}
        </Group>
        <Group title={t("book.decadeT")}>
          {decades.map((d) => <Opt key={d.decade} on={value.decada === String(d.decade)} label={`${String(d.decade).slice(2)}'s`} count={d.count} onClick={() => toggle("decada", d.decade)} testid={`filter-decade-${d.decade}`} />)}
        </Group>
      </div>
    </div>
  );
};
